import Vue from 'vue';
import {
  clone, cloneDeep, orderBy, findIndex,
} from 'lodash';
import api from 'src/api';

// в константы выносим только названия мутаций,
// которые переиспользуем/планируем переиспользовать
export const SET_FETCHING = 'SET_FETCHING';
export const SET_STOP_FETCHING = 'SET_STOP_FETCHING';

const data = {
  activityNotifications: [],
  activityEvents: [],
  fething: false,
};

const actions = {
  fetchActivityNotifications({ commit }) {
    commit(SET_FETCHING);
    return api.getActivityNotifications().then((res) => commit('SYNC_ACTIVITY_NOTIFICATIONS', res))
      .catch((err) => {
        commit(SET_STOP_FETCHING);
        throw err;
      });
  },
  fetchActivityNotificationEvents({ commit }) {
    commit(SET_FETCHING);
    return api.getActivityNotificationEvents().then((res) => commit('SYNC_EVENTS', res))
      .catch((err) => {
        commit(SET_STOP_FETCHING);
        throw err;
      });
  },
  createActivityNotification({ commit }, { model }) {
    return api.createActivityNotification(model).then((res) => {
      commit('ADD_ACTIVITY_NOTIFICATION', res);
    });
  },
  updateActivityNotification({ commit }, { id, model }) {
    return api.updateActivityNotification(id, model).then((res) => {
      commit('UPDATE_ACTIVITY_NOTIFICATION', res);
    });
  },
  removeActivityNotification({ commit }, id) {
    commit(SET_FETCHING);
    return api.deleteActivityNotification(id)
      .then(() => commit('REMOVE_ACTIVITY_NOTIFICATION', id))
      .catch((err) => {
        commit(SET_STOP_FETCHING);
        throw err;
      });
  },
};

const mutations = {
  SET_FETCHING(state) {
    state.fetching = true;
  },
  SET_STOP_FETCHING(state) {
    state.fetching = false;
  },
  SYNC_ACTIVITY_NOTIFICATIONS(state, payload) {
    state.activityNotifications = cloneDeep(orderBy(payload, 'name'));
    mutations.SET_STOP_FETCHING(state);
  },
  SYNC_EVENTS(state, payload) {
    state.activityEvents = cloneDeep(payload.map((item) => item.name));
    mutations.SET_STOP_FETCHING(state);
  },
  UPDATE_ACTIVITY_NOTIFICATION(state, res) {
    const { id } = res;
    const { activityNotifications } = state;
    const index = findIndex(activityNotifications, { id });
    Vue.set(activityNotifications, index, { ...activityNotifications[index], ...res });
  },
  REMOVE_ACTIVITY_NOTIFICATION(state, id) {
    const { activityNotifications } = state;
    Vue.delete(activityNotifications, findIndex(activityNotifications, { id }));
  },
  ADD_ACTIVITY_NOTIFICATION(state, res) {
    state.activityNotifications.push(clone(res));
  },
};

const getters = {
  getActivityNotificationById(state) {
    const { activityNotifications } = state;
    return (id) => (activityNotifications[findIndex(activityNotifications, { id })]);
  },
};

const store = {
  namespaced: true,
  state: data,
  mutations,
  getters,
  actions,
};

export default store;
